export class DocumentUtils {
    static clean(value) {
        return String(value || "")
            .replace(/[^0-9A-Za-z]/g, "")
            .toUpperCase()
            .slice(0, 14);
    }

    static isValidCpf(value) {
        const cpf = this.clean(value);
        if (!/^\d{11}$/.test(cpf)) return false;
        if (/^(\d)\1{10}$/.test(cpf)) return false;

        const calcDigit = (base, factorStart) => {
            let total = 0;
            let factor = factorStart;
            for (const digit of base) total += Number(digit) * factor--;
            const rest = total % 11;
            return rest < 2 ? 0 : 11 - rest;
        };

        const digit1 = calcDigit(cpf.slice(0, 9), 10);
        const digit2 = calcDigit(cpf.slice(0, 9) + digit1, 11);
        return cpf.slice(9) === `${digit1}${digit2}`;
    }

    static isValidCnpj(value) {
        const cnpj = this.clean(value);
        if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;

        const charValue = (char) => char.charCodeAt(0) - 48;
        const calcDigit = (base, weights) => {
            let total = 0;
            for (let i = 0; i < base.length; i++) {
                total += charValue(base[i]) * weights[i];
            }
            const rest = total % 11;
            return rest < 2 ? 0 : 11 - rest;
        };

        const base = cnpj.slice(0, 12);
        const digit1 = calcDigit(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
        const digit2 = calcDigit(
            base + digit1,
            [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        );
        return cnpj.slice(12) === `${digit1}${digit2}`;
    }

    static isValidDocument(value) {
        const cleaned = this.clean(value);
        if (cleaned.length === 11) return this.isValidCpf(cleaned);
        if (cleaned.length === 14) return this.isValidCnpj(cleaned);
        return false;
    }
}
